var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f57224;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_14_comment",
    "data-name": "14 comment"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.67,18.67c-.1,0-.2-.02-.29-.07-.23-.11-.38-.34-.38-.6v-3.33H2c-1.1,0-2-.9-2-2V2C0,.9.9,0,2,0h16c1.1,0,2,.9,2,2v10.67c0,1.1-.9,2-2,2h-8.1l-4.82,3.85c-.12.1-.27.15-.42.15ZM2,1.33c-.37,0-.67.3-.67.67v10.67c0,.37.3.67.67.67h2.67c.37,0,.67.3.67.67v2.61l3.92-3.13c.12-.09.26-.15.42-.15h8.33c.37,0,.67-.3.67-.67V2c0-.37-.3-.67-.67-.67H2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.33,6.67H4.67c-.37,0-.67-.3-.67-.67s.3-.67.67-.67h10.67c.37,0,.67.3.67.67s-.3.67-.67.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,9.33h-5.33c-.37,0-.67-.3-.67-.67s.3-.67.67-.67h5.33c.37,0,.67.3.67.67s-.3.67-.67.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.785a8bd5e244a2eb52ec363d6944a1f8.svg";
export { ForwardRef as ReactComponent };